import React, { useState, useEffect } from "react";
import * as announcementApi from "../../../api/announcementApi";
import { toast } from "react-toastify";
import { AnnouncementsForm } from "../../forms/Master/AnnouncementsForm";
import PropTypes from "prop-types";
import { showDeleteConfirm } from "../../common/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function AnnouncementsPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [announcements, setAnnouncements] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const location = useLocation();
  let defaultPagination = location.state
    ? location.state.currentPage
      ? location.state.currentPage
      : 1
    : 1;
  const [currentPage, setCurrentPage] = useState(defaultPagination);

  useEffect(getAnnouncements, []);

  function getAnnouncements() {
    announcementApi
      .getAllAnnouncements()
      .then((result) => {
        setIsLoading(false);
        setAnnouncements(result);
      })
      .catch((error) => {
        setIsLoading(false);
        setAnnouncements([]);
        showErrorMessage(t("general.fail_to_load_record") + error.message);
      });
  }

  function addNewItem() {
    history("/home/announcements/announcement", {
      state: { currentPage: currentPage },
    });
  }

  function editItem(announcementKey) {
    history("/home/announcements/announcement/" + announcementKey, {
      state: { currentPage: currentPage },
    });
  }

  function onDelete(announcementKey) {
    showDeleteConfirm("Announcement", announcementKey, deleteAnnouncement, t);
  }

  function deleteAnnouncement(announcementKey) {
    setIsLoading(true);
    announcementApi
      .deleteAnnouncement(announcementKey)
      .then(() => {
        const newData = announcements.filter(
          (item) => item.AnnouncementKey !== announcementKey
        );
        setAnnouncements(newData);
        setIsLoading(false);
        toast.success(t("general.record_deleted_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_delete_record") + error.message);
      });
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function onRowSelected(value) {
    if (value.UpdatedDate) {
      value.UpdatedOn = value.UpdatedDate;
    }
    if (value.CreatedDate) {
      value.CreatedOn = value.CreatedDate;
    }
    setRowSelected(value);
  }

  return (
    <AnnouncementsForm
      isLoading={isLoading}
      announcements={announcements}
      onAdd={addNewItem}
      onEdit={editItem}
      onDelete={onDelete}
      onRowSelected={onRowSelected}
      rowSelected={rowSelected}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

AnnouncementsPage.propTypes = {
  history: PropTypes.func.isRequired,
};
